import { createTheme, alpha } from "@mui/material/styles";
import typography from "../theme/typography";
import shadows, { customShadows } from "../theme/shadows";
import shape from "../theme/shape";
import basePalette from "../theme/palette";
import ComponentsOverride from "../theme/overrides";

export const useDomainTheme = (domainConfig) => {
  // Merge the designed base palette (greys, text, background, gradients) with the
  // per-domain brand colors so we don't fall back to bare MUI defaults.
  const domainPalette = domainConfig.palette;
  const palette = {
    ...basePalette,
    primary: { ...basePalette.primary, ...domainPalette.primary },
    secondary: { ...basePalette.secondary, ...domainPalette.secondary },
    gradients: {
      ...basePalette.gradients,
      primary: `linear-gradient(to bottom, ${
        domainPalette.primary.light || domainPalette.primary.main
      }, ${domainPalette.primary.main})`,
    },
  };

  // Existing: set favicon from domain config
  const publicUrl = process.env.PUBLIC_URL || '';
  // Support both local public-folder files (relative) and absolute hosted URLs
  const faviconHref = /^https?:\/\//.test(domainConfig.faviconUrl)
    ? domainConfig.faviconUrl
    : `${publicUrl}/${domainConfig.faviconUrl}`;
  let faviconLink = document.getElementById("favicon");
  if (faviconLink) {
    faviconLink.href = faviconHref;
  } else {
    faviconLink = document.createElement("link");
    faviconLink.id = "favicon";
    faviconLink.rel = "icon";
    faviconLink.href = faviconHref;
    document.head.appendChild(faviconLink);
  }
  // Existing: inject CSS variable for --app-color
  const dynamicVariables = `
  :root {
    --app-color: ${palette.primary.main};
  }
  `;
  const styleElement = document.createElement("style");
  styleElement.appendChild(document.createTextNode(dynamicVariables));
  document.head.appendChild(styleElement);

  // Updated: pass full theme config (palette + typography + shadows + shape)
  const updatedCustomShadows = {
    ...customShadows,
    primary: `0 8px 16px 0 ${alpha(palette.primary.main, 0.24)}`,
  };

  const domainTheme = createTheme({
    palette,
    shape,
    typography,
    shadows,
    customShadows: updatedCustomShadows,
  });

  // Apply component overrides
  domainTheme.components = ComponentsOverride(domainTheme);

  return domainTheme;
};
